<template>
 <div>
	<template v-if="transactionLogs === true">
        <div v-show="isDataTableLoading === false">
			<div class="page-top mb-1 mb-3 align-left clearfix">
				<h1>Transaction Logs</h1>
			</div>

			<!-- New Batch Modal -->
			<div class="modal fade" id="responseDetailModal" tabindex="-1" role="dialog" aria-labelledby="responseDetailLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="width:100%">
					<div class="modal-content">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
						<div class="modal-body">
							<div class="popup-head line-head mt-4 mb-5">
								<h2 class="pb-3"> Log Details </h2>
							</div>
							<div class="transaction-log-boxes-holder">
								<div class="">
									<table id="logdetails" class="table" style="width:100%">
										<thead>
											<tr style="word-wrap: break-word;">
												<th>Company</th>
												<th>Payment Engine</th>
												<th>Transaction Type</th>
												<th>Mobile#</th>
												<th>End Point</th>
												<th>Action Method</th>
											</tr>
										</thead>

										<tbody>
											<tr style="word-wrap: break-word;">
												<td>{{logDetails.compnay_name}}</td>
												<td>{{logDetails.payment_engine}}</td>
												<td>{{logDetails.transaction_type}}</td>
												<td>{{logDetails.mobile_no}}</td>
												<td>{{logDetails.end_point}}</td>
												<td>{{logDetails.action_method}}</td>
											</tr>
										</tbody>
									</table>
									<div class="">
										<table id="logdetails" class="table" style="width:100%">
											<thead>
												<tr>
													<th>Response Date</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>{{logDetails.response_data}}</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="">
										<table id="logdetails" class="table" style="width:100%">
											<thead>
												<tr>
													<th>Payload</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>{{logDetails.payload}}</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="">
										
										<table id="logdetails" class="table" style="width:100%">
											<thead>
												<tr>
													<th>Response</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>{{logDetails.response}}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-12">
				<div class="row">
					<div class="col-md-2">
						<div class="form-group">
							<label class="label block-label"> From Date </label>
							<datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
						</div>
					</div>
					<div class="col-md-2">
						<div class="form-group">
							<label class="label block-label"> To Date </label>
							<datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
						</div>
					</div>
					<div class="col-md-3">
						<div class="form-group">
							<label> Company </label>
							<select v-model="company_id" data-live-search="true" name="company_id" class="selectpicker custom-select2 form-control" v-if="companies != null" >
								<option value="" selected>Select Company</option>
								<option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">{{ company.name }} - {{ company.walletID }}</option>
							</select>
						</div>
					</div>
					<div class="col-md-2">
						<div class="form-group">
							<label> Payment Rail </label>
							<select v-model="log_type" name="log_type" class="form-control" >
								<option value="" selected>Select Payment Rail</option>
								<option value="em-api-logs">Emoney</option>
								<option value="ep-api-logs">EasyPasia</option>
								<option value="finca-api-logs">Finca</option>
								<option value="mbl-api-logs">MEEZAN</option>
							</select>
						</div>
					</div>
					<div class="col-md-2">
						<div class="form-group">
							<label> Request Status </label>
							<select v-model="request_status" name="request_status" class="form-control" >
								<option value="" selected>Select Request Status</option>
								<option value="success">Success</option>
								<option value="error">Error</option>
							</select>
						</div>
					</div>
					<div class="col-md-1">
						<div class="form-group">
							<button id="filterTable" class="btn btn-primary">Search</button>
						</div>
					</div>
				</div>
			</div>
			<div class="page-top mb-1 mb-3 clearfix">
				<ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
					<li class="nav-item">
						<a class="nav-link active" id="ibftLogs-tab" data-toggle="tab" href="#ibftLogs" role="tab" aria-controls="ibftLogs" aria-selected="true" @click="reloadList('ibftLogs')">IBFT</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" id="lftLogs-tab" data-toggle="tab" href="#lftLogs" role="tab" aria-controls="lftLogs" aria-selected="false" @click="reloadList('lftLogs')">LFT</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" id="titleFetchLogs-tab" data-toggle="tab" href="#titleFetchLogs" role="tab" aria-controls="titleFetchLogs" aria-selected="false" @click="reloadList('titileFetchLogs')">Title Fetch</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" id="otherLogs-tab" data-toggle="tab" href="#otherLogs" role="tab" aria-controls="otherLogs" aria-selected="false" @click="reloadList('otherLogs')">Others</a>
					</li>
				</ul>
				<div class="searching float-right mr-2">
                    <input id="search_active" type="text" placeholder="Search" class="form-control search" name="" />
                </div>
			</div>
			<div class="tab-content" id="myTabContent">
				<div class="corporate-head pb-3 clearfix">
					<div class="dt-buttons" id="buttons">
						<button @click="downloadExcel()"  class="btn btn-primary">Download Excel</button>
					</div>
				</div>
				<div class="tab-pane fade show active" id="ibftLogs" role="tabpanel" aria-labelledby="ibftLogs-tab">
					<table id="dt-ibft" class="table" style="width:100%">
						<thead>
							<tr>
								<th>Date</th>
								<th>Company</th>
								<th>Payment Rail</th>
								<th>Payment Engine</th>
								<th>Request Status</th>
								<th>Batch ID</th>
								<th>Transaction Type</th>
								<th>Mobile#</th>
								<th>Account#</th>
								<th>Response Code</th>
								<th>Response Description</th>
								<th style="width:100px">Action</th>
							</tr>
						</thead>
					</table>
				</div>
				<div class="tab-pane fade" id="lftLogs" role="tabpanel" aria-labelledby="lftLogs-tab">
					<table id="dt-lft" class="table" style="width:100%">
						<thead>
							<tr>
								<th>Date</th>
								<th>Company</th>
								<th>Payment Rail</th>
								<th>Payment Engine</th>
								<th>Request Status</th>
								<th>Batch ID</th>
								<th>Transaction Type</th>
								<th>Mobile#</th>
								<th>Account#</th>
								<th>Response Code</th>
								<th>Response Description</th>
								<th style="width:100px">Action</th>
							</tr>
						</thead>
					</table>
				</div>
				<div class="tab-pane fade" id="titleFetchLogs" role="tabpanel" aria-labelledby="titleFetchLogs-tab">
					<table id="dt-title-fetch" class="table" style="width:100%">
						<thead>
							<tr>
								<th>Date</th>
								<th>Company</th>
								<th>Payment Rail</th>
								<th>Payment Engine</th>
								<th>Request Status</th>
								<th>Batch ID</th>
								<th>Transaction Type</th>
								<th>Mobile#</th>
								<th>Account#</th>
								<th>Response Code</th>
								<th>Response Description</th>
								<th style="width:100px">Action</th>
							</tr>
						</thead>
					</table>
				</div>
				<div class="tab-pane fade" id="otherLogs" role="tabpanel" aria-labelledby="otherLogs-tab">
					<table id="dt-others" class="table" style="width:100%">
						<thead>
							<tr>
								<th>Date</th>
								<th>Company</th>
								<th>Payment Rail</th>
								<th>Payment Engine</th>
								<th>Request Status</th>
								<th>Batch ID</th>
								<th>Transaction Type</th>
								<th>Mobile#</th>
								<th>Account#</th>
								<th>Response Code</th>
								<th>Response Description</th>
								<th style="width:100px">Action</th>
							</tr>
						</thead>
					</table>
				</div>
			</div>
		</div>
		<preLoader v-show="isDataTableLoading === true"></preLoader>
	</template>
    <template v-else-if="transactionLogs === null">
        <preLoader></preLoader>
    </template>
    <template v-else-if="transactionLogs === false">
		<notAllowed></notAllowed>
    </template>
 </div>
</template>

<script>
    export default {
        data() {
            return {
				transactionLogs : true,
				isDataTableLoading: false,
				currentActiveTab: "ibftLogs",
				dtibft: null,
				dtlft: null,
				dttitle: null,
				dtothers: null,
				form: new Form({
                    log_id: '',
					log_table: ''
                }),
				logDetails: {},
				from_date : '',
                to_date : '',
				showBtn: false,
				companies: {},
				company_id: '',
				log_type: '',
				request_status: '',
			};
		},
        mounted() {
			let self = this;
			self.getCompanies();
			this.can('transaction_logs').then(result => {
                this.transactionLogs = result.transaction_logs;
            }).then(result => {
                if(this.transactionLogs == true){
					self.dtibft = $('#dt-ibft').DataTable({
						sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
						processing: true,
						serverSide: true,
						pageLength: 10,
						searching :true,
						buttons: [],
						ajax: {
							"url": "api/listIbftLogs",
							"data": function (d) {
								d.from_date = moment(self.from_date).format('YYYY-MM-DD');
								d.to_date = moment(self.to_date).format('YYYY-MM-DD');
								d.company_id = self.company_id;
								d.log_type = self.log_type;
								d.request_status = self.request_status;
							},
							"headers": window.axios.defaults.headers.common,
							"dataSrc": "records",
						},
						deferRender: true,
						columns: [
							{data: 'created_at'},
							{data: 'compnay_name'},
							{data: 'log_type'},
							{data: 'payment_engine'},
							{data: 'request_status'},
							{data: 'batch_id'},
							{data: 'transaction_type'},
							{data: 'mobile_no'},
							{data: 'account_no'},
							{data: 'response_code'},
							{data: 'response_description'},
							{data: 'id', sorting: false, render: function(data,type,full){
								return '<a href="javascript:void(0);" data-id="'+full['id']+'" class="action edit responseDetailsIbft"><i class="far fa-eye"></i></a>';
							}},
						],
						"drawCallback": function() {
							$(".action").tooltip();
							$("a.responseDetailsIbft").click(function () {
								self.responseDetails();
							});
						},
						"order": [[ 0, "desc" ]],
					});
				
					self.dtlft = $('#dt-lft').DataTable({
						sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
						processing: true,
						serverSide: true,
						pageLength: 10,
						searching :true,
						buttons: [],
						ajax: {
							"url": "api/listLftLogs",
							"data": function (d) {
								d.from_date = moment(self.from_date).format('YYYY-MM-DD');
								d.to_date = moment(self.to_date).format('YYYY-MM-DD');
								d.company_id = self.company_id;
								d.log_type = self.log_type;
								d.request_status = self.request_status;
							},
							"headers": window.axios.defaults.headers.common,
							"dataSrc": "records",
						},
						deferRender: true,
						columns: [
							{data: 'created_at'},
							{data: 'compnay_name'},
							{data: 'log_type'},
							{data: 'payment_engine'},
							{data: 'request_status'},
							{data: 'batch_id'},
							{data: 'transaction_type'},
							{data: 'mobile_no'},
							{data: 'account_no'},
							{data: 'response_code'},
							{data: 'response_description'},
							{data: 'id', sorting: false, render: function(data,type,full){
								return '<a href="javascript:void(0);" data-id="'+full['id']+'" class="action edit responseDetailsLft"><i class="far fa-eye"></i></a>';
							}},
						],
						"drawCallback": function() {
							$(".action").tooltip();
							$("a.responseDetailsLft").click(function () {
								self.responseDetails();
							});
						},
						"order": [[ 0, "desc" ]],
					});
				
					self.dttitle = $('#dt-title-fetch').DataTable({
						sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
						processing: true,
						serverSide: true,
						pageLength: 10,
						searching :true,
						buttons: [],
						ajax: {
							"url": "api/listTitleFetchLogs",
							"data": function (d) {
								d.from_date = moment(self.from_date).format('YYYY-MM-DD');
								d.to_date = moment(self.to_date).format('YYYY-MM-DD');
								d.company_id = self.company_id;
								d.log_type = self.log_type;
								d.request_status = self.request_status;
							},
							"headers": window.axios.defaults.headers.common,
							"dataSrc": "records",
						},
						deferRender: true,
						columns: [
							{data: 'created_at'},
							{data: 'compnay_name'},
							{data: 'log_type'},
							{data: 'payment_engine'},
							{data: 'request_status'},
							{data: 'batch_id'},
							{data: 'transaction_type'},
							{data: 'mobile_no'},
							{data: 'account_no'},
							{data: 'response_code'},
							{data: 'response_description'},
							{data: 'id', sorting: false, render: function(data,type,full){
								return '<a href="javascript:void(0);" data-id="'+full['id']+'" class="action edit responseDetailsTitleFetch"><i class="far fa-eye"></i></a>';
							}},
						],
						"drawCallback": function() {
							$(".action").tooltip();
							$("a.responseDetailsTitleFetch").click(function () {
								self.responseDetails();
							});
						},
						"order": [[ 0, "desc" ]],
					});
				
					self.dtothers = $('#dt-others').DataTable({
							sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
							processing: true,
							serverSide: true,
							pageLength: 10,
							searching :true,
							buttons: [],
							ajax: {
								"url": "api/listOtherLogs",
								"data": function (d) {
									d.from_date = moment(self.from_date).format('YYYY-MM-DD');
									d.to_date = moment(self.to_date).format('YYYY-MM-DD');
									d.company_id = self.company_id;
									d.log_type = self.log_type;
									d.request_status = self.request_status;
								},
								"headers": window.axios.defaults.headers.common,
								"dataSrc": "records",
							},
							deferRender: true,
							columns: [
								{data: 'created_at'},
								{data: 'compnay_name'},
								{data: 'log_type'},
								{data: 'payment_engine'},
								{data: 'request_status'},
								{data: 'batch_id'},
								{data: 'transaction_type'},
								{data: 'mobile_no'},
								{data: 'account_no'},
								{data: 'response_code'},
								{data: 'response_description'},
								{data: 'id', sorting: false, render: function(data,type,full){
									return '<a href="javascript:void(0);" data-id="'+full['id']+'" class="action edit responseDetailsApp"><i class="far fa-eye"></i></a>';
								}},
							],
							"drawCallback": function() {
								$(".action").tooltip();
								$("a.responseDetailsApp").click(function () {
									self.responseDetails();
								});
							},
							"order": [[ 0, "desc" ]],
						});
				}else{
                    this.$Progress.finish();
                }
			});

			$('#search_active').on( 'keyup', function (e) {
				if (e.keyCode === 13) {
					if(self.currentActiveTab == 'ibftLogs'){
						self.dtibft.search(this.value).draw();
					}
					if(self.currentActiveTab == 'lftLogs'){
						self.dtlft.search(this.value).draw();
					}
					if(self.currentActiveTab == 'titileFetchLogs'){
						self.dttitle.search(this.value).draw();
					}
					if(self.currentActiveTab == 'otherLogs'){
						self.dtothers.search(this.value).draw();
					}
				}
			});

			$('#filterTable').on( 'click', function (e) {
				if(self.currentActiveTab == 'ibftLogs'){
					self.dtibft.search(this.value).draw();
				}
				if(self.currentActiveTab == 'lftLogs'){
					self.dtlft.search(this.value).draw();
				}
				if(self.currentActiveTab == 'titileFetchLogs'){
					self.dttitle.search(this.value).draw();
				}
				if(self.currentActiveTab == 'otherLogs'){
					self.dtothers.search(this.value).draw();
				}
			});
        },
		methods: {
			reloadList(tabClicked){
				var self = this;
				switch(tabClicked)
				{					
					case 'ibftLogs':
						if(self.currentActiveTab !== 'ibftLogs')
						{
							self.isDataTableLoading = true;
							self.dtibft.ajax.reload(function(json){
								self.isDataTableLoading = false;
							}, false);
							self.currentActiveTab = 'ibftLogs';	
						}
					break;

					case 'lftLogs':
						if(self.currentActiveTab !== 'lftLogs')
						{
							self.isDataTableLoading = true;
							self.dtlft.ajax.reload(function(json){
								self.isDataTableLoading = false;
							}, false);
							self.currentActiveTab = 'lftLogs';
						}
					break;

					case 'titileFetchLogs':
						if(self.currentActiveTab !== 'titileFetchLogs')
						{
							self.isDataTableLoading = true;
							self.dttitle.ajax.reload(function(json){
								self.isDataTableLoading = false;
							}, false);
							self.currentActiveTab = 'titileFetchLogs';
						}
					break;

					case 'otherLogs':
						if(self.currentActiveTab !== 'otherLogs')
						{
							self.isDataTableLoading = true;
							self.dtothers.ajax.reload(function(json){
								self.isDataTableLoading = false;
							}, false);
							self.currentActiveTab = 'otherLogs';
						}
					break;
				}
			},
			
			responseDetails(){
				if(this.currentActiveTab == 'ibftLogs'){
					var id = $('a.responseDetailsIbft').data("id");

					this.form.log_id = id;
					this.form.log_table = "ibft_logs";
				}
				if(this.currentActiveTab == 'lftLogs'){
					var id = $('a.responseDetailsLft').data("id");
					this.form.log_id = id;
					this.form.log_table = "lft_logs";
				}
				if(this.currentActiveTab == 'titileFetchLogs'){
					var id = $('a.responseDetailsTitleFetch').data("id");
					this.form.log_id = id;
					this.form.log_table = "title_fetch_logs";
				}
				if(this.currentActiveTab == 'otherLogs'){
					var id = $('a.responseDetailsApp').data("id");
					this.form.log_id = id;
					this.form.log_table = "app_logs";
				}

				this.getResponseDetail();
				
			},

			getResponseDetail(){
				this.$Progress.start();
                this.form.post('/api/getResponseDetail')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.logDetails = res.data.logDetails;
						// this.logDetails =  logDetails[0]
						console.log(this.logDetails);
                        $('#responseDetailModal').modal('show');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },

			downloadExcel: function(){
                this.$Progress.start();
                let that=this
                var formData = {
                    'log_table': that.currentActiveTab,
					'from_date':moment(that.from_date).format('YYYY-MM-DD'),
					'to_date':moment(that.to_date).format('YYYY-MM-DD'),
					'company_id' : that.company_id,
					'log_type' : that.log_type,
					'request_status' : that.request_status,
                }
                axios.post('/api/downloadExcel',formData,{
                    responseType: 'blob'
                })
                .then((response) => {
                    console.log(response);
                    if(response.status == 200){
                        this.$Progress.finish();
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/vnd.ms-excel'
                        }))

						let file_name =that.currentActiveTab+".xlsx";
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', file_name)
                        document.body.appendChild(link)
                        link.click()
                        this.$Progress.finish();
                    }else{
                        this.showAlertBox('error','There is some problem');
                    }

                }).catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },

			getCompanies(){
                this.$Progress.start();
                axios.get('/api/listActiveCompanies')
                .then(res => {
                    if(res.status == 200){
                        this.companies = res.data;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Some error in your form data');
                });
            }
		}
    }
</script>
